import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '& $container': {
        paddingBottom: '68px',
        [muiTheme.breakpoints.up('md')]: {
          paddingBottom: '40px',
        },
      },
    },
    container: {},
  }),
  { name: 'GenPartnerSolutions' },
);
export default useStyles;
